import React, { useState } from 'react';
import Bunexe_service from '../../Bunexe_service';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

const Departement_perm = ({
  setCurrentform,
  currentform,
  departement,
  setDepartement_,
}) => {
  const [departement_temp, setDepartement_temp] = useState(departement);
  const updateDepartement = (dept) => {
    console.log(dept);
    setDepartement_temp(dept);
    setDepartement_(dept);
  };
  return (
    <div className='row'>
      <div className='col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2'>
        <div className='card mb-3'>
          <div className='card-header'>
            <h2 className='display-5 text-center'>
              Departement dans lequel vous vivez?
            </h2>
          </div>
          <div className='card-body'>
            <Form>
              <Form.Row>
                <Form.Group as={Col} controlId='formDepartement'>
                  <Form.Label>Departement</Form.Label>
                  <Form.Control
                    as='select'
                    value={departement_temp}
                    onChange={(e) => {
                      updateDepartement(e.target.value);
                    }}
                  >
                    {Bunexe_service.depts.map((d, index) => (
                      <option key={index} value={d.code}>
                        {d.titre}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <div className='d-flex justify-content-end mt-4'>
                  <button
                    className='btn btn-small btn-info'
                    onClick={(e) => {
                      setDepartement_(departement_temp);
                      setCurrentform(currentform + 1);
                    }}
                  >
                    Continuer
                  </button>
                </div>
              </Form.Row>
            </Form>
          </div>

          <div className='card-footer'>
            {/*            
            <div className='d-flex justify-content-between mt-4'>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform - 1)}
              >
                Accueil
              </button>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform + 1)}
              >
                Siège
              </button>
            </div>
          */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Departement_perm;
